import React from 'react';
import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Container, Header, Image, Menu, Segment,
} from 'semantic-ui-react';
import logoutLogo from '@/assets/images/logout-logo.svg';
import Selectors from '@/themes/hooks/selectors';

const LogoutContainer = () => {
  const intl = useIntl();
  const { theme } = Selectors.useTheme();
  return (
    <>
      <Menu inverted className={clsx('nav fixed no-full-screen', `aridhia-theme-${theme}`)} />
      <Container className={clsx('page content aridhia-logout-page', `aridhia-theme-${theme}`)}>
        <Segment className="container" textAlign="center" size="large" padded="very">
          <Image src={logoutLogo} size="small" centered alt={intl.formatMessage({ id: 'logout.icon.alt' })} />
          <Header as="h2">
            <FormattedMessage id="logout.title" />
          </Header>
          <Header as="h4">
            <FormattedMessage id="logout.content" />
          </Header>
        </Segment>
      </Container>
    </>
  );
};

export default LogoutContainer;
